module.exports = __webpack_public_path__ + "img/blue-hamburger.6028d7f4.svg";